export default "__VITE_ASSET__DmxX8_qN__"